"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutButton = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CheckoutButton = (0, _styledComponents["default"])(_slice.Button)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  color: white;\n  background-color: ", ";\n  border-color: ", ";\n  width: 100%;\n\n  &:disabled {\n    background-color: #58595b;\n    opacity: 35%;\n    border-color: #58595b;\n    cursor: default;\n    pointer-events: none;\n  }\n"], ["\n  color: white;\n  background-color: ", ";\n  border-color: ", ";\n  width: 100%;\n\n  &:disabled {\n    background-color: #58595b;\n    opacity: 35%;\n    border-color: #58595b;\n    cursor: default;\n    pointer-events: none;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});
exports.CheckoutButton = CheckoutButton;
var templateObject_1;